/* eslint-disable no-extra-semi */
/* eslint-disable unused-imports/no-unused-imports */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/prefer-for-of */
import { Injectable } from '@angular/core';
import { DataModel, FileModel, User, listToDictionary, StorageService, AppVariables } from '@shared';
import { LoggingService } from '@shared/logging';
import { DataRepository } from '../repositories/data.repository';
import { WorkspaceDatabaseKeys } from '../schemas';
import { RxdbIdProvider } from './rxdb-id.provider';
import { firstValueFrom } from 'rxjs';
import jwt_decode from 'jwt-decode';
import { DecodeJWTResultModel } from '@domain/registration';
import { RefTablesStorageService } from '@database/workspace';
import { DeviceIdProvider } from '@database/workspace';

@Injectable({
	providedIn: 'root'
})
export class WorkspaceDataImporterService {
	public constructor(
		private dataRepository: DataRepository,
		private rxdbIdProvider: RxdbIdProvider,
		private logger: LoggingService,
		private storageService: StorageService,
		private deviceIdProvider: DeviceIdProvider,
		private refTablesStorageService: RefTablesStorageService
	) { }

	public async importData(
		data: DataModel[],
		workfileId: string,
		rxdbid: number = 0,
		isAppend: boolean = false,
		fileModel: FileModel = null
	): Promise<void> {
		const itemProcessFunction = (item: DataModel): void => {
			Object.keys(item).forEach((key) => {
				if (item[key] === undefined) {
					delete item[key];
				}
			});

			rxdbid++;

			item['rxdbid'] = rxdbid;
			item['rxdbidstring'] = rxdbid.toString();
			item['isDeleted'] = false;
		};

		if (data.length == 0) {
			return
		}
		var resMap = listToDictionary(WorkspaceDatabaseKeys.tables.tableName, data, itemProcessFunction);
		try {
			if (isAppend) {
				const storedDeviceId: string = await this.deviceIdProvider.getDeviceId();
				const decodedToken: DecodeJWTResultModel = jwt_decode(fileModel.FusionConfigHeader[0].registration_token);
				if (decodedToken.dev.length > 0 && decodedToken.dev.toString() != storedDeviceId) {
					throw new Error('Your device is not registered on this Workfile. Please try another one.');
				}

				const fusionUserId: string = await this.getFusionUserId();
				const userHasAccess = fileModel.FusionUsers.find((user: User) => user.userid === fusionUserId);

				if (!userHasAccess) {
					throw new Error('You do not have access to this file. Please import another one.');
				}

				const tableNamesRaw = [...new Set(data.map((item) => item.table_name))];
				const tableNames = new Set<string>([
					...tableNamesRaw.filter(name => name !== undefined && name !== "START_STUB" && name !== "END_STUB")
				]);

				for (const tableName of tableNames) {
					var existData = await firstValueFrom(this.dataRepository.getAllTableData$(tableName));
					var isTableParent = this.isTableParent(tableName, fileModel)

					if (!isTableParent) {
						continue;
					}

					var primaryKeys: string[] = [];
					if (fileModel.FusionEntities) {
						for (const entity of fileModel.FusionEntities) {
							if (entity.entity_name == tableName) {
								primaryKeys.push(...entity.primary_key)
							}
						}
					}

					for (const newItem of resMap[tableName]) {
						for (const item of existData) {
							let isDuplicate = true;
							for (const key of primaryKeys) {
								if (item[key] !== newItem[key]) {
									isDuplicate = false;
									break;
								}
							}

							if (isDuplicate) {
								if (newItem.is_master) {
									if (newItem.is_master === "N") {
										throw new Error('Record is never eligible for transfer out of DHL.');
									}

									if (item && newItem.is_master === "Y" && item.is_master === "Y") {
										throw new Error('Record already exists as a master in QuickLogger – append cancelled.');
									}
								}

								await this.clearAllParentChildData(primaryKeys, item, fileModel, tableNames, tableName);
							}
						}
					}
				};
			}
			await this.dataRepository.bulkInsert(this.sanitizeData(resMap));
			await this.rxdbIdProvider.setRxdbId(workfileId, rxdbid);

			if (isAppend) {
				this.refreshPickListData(workfileId, fileModel)
			}
		} catch (error) {
			this.logger.error('Bulk insert. Import Data', error);
			throw error;
		}
	}

	private isTableParent(tableNameParam: string, fileModel: FileModel): Boolean {
		const fusionDataTables = fileModel.FusionDataTables;

		for (let i = 0; i < fusionDataTables.length; i++) {
			if (tableNameParam.toLowerCase() == fusionDataTables[i].table_name.toLocaleLowerCase()) {
				if (fusionDataTables[i].child_table_ids.length > 0) {
					return true;
				}
			}
		}
		return false;
	}

	private async clearAllParentChildData(primaryKeys: string[], existData: DataModel, fileModel: FileModel, tableNames: Set<string>, tableName: string) {
		const fusionDataTables = fileModel.FusionDataTables;
		const childTableNames: string[] = [];

		const parentTable = fusionDataTables.find(
			table => existData.table_name.toLowerCase() === table.table_name.toLowerCase()
		);

		const childTableIdList: number[] = parentTable?.child_table_ids
			? parentTable.child_table_ids.split(',').map(id => Number(id)).filter(n => !isNaN(n))
			: [];

		for (const table of fusionDataTables) {
			if (childTableIdList.includes(table.table_id) && tableNames.has(table.table_name)) {
				childTableNames.push(table.table_name);
			}
		}

		for (const childTableName of childTableNames) {
			const childItems = await firstValueFrom(this.dataRepository.getAllTableData$(childTableName));
			for (const item of childItems) {
				let isDeleteChild = true;
				for (const key of primaryKeys) {
					if (existData[key] !== item[key]) {
						isDeleteChild = false;
						break;
					}
				}
				if (isDeleteChild) {
					await this.dataRepository.delete(childTableName, item.rxdbid);
				}
			}
		}

		await this.dataRepository.delete(tableName, existData.rxdbid);
	}

	private async refreshPickListData(workfileId: string, fileModel: FileModel) {
		if (fileModel.FusionReferenceTables) {
			const fusionReferenceTables = fileModel.FusionReferenceTables;
			const groupedByTableName = this.groupByTableName(fusionReferenceTables);

			const existingKeys = await this.refTablesStorageService.getKeys(workfileId);

			for (const [tableName, items] of groupedByTableName.entries()) {
				const lowerCaseTableName = tableName.toLowerCase();
				const storageKey = `${workfileId}${AppVariables.INTERNAL_STORAGE_REF_TABLE_PREFIX}${lowerCaseTableName}`;

				const lowerCasedItems = items.map((item: any) => {
					return Object.keys(item).reduce((acc: any, key: string) => {
						acc[key.toLowerCase()] = item[key];
						return acc;
					}, {});
				});

				if (existingKeys.includes(storageKey)) {
					console.log(`${workfileId}_${lowerCaseTableName}_${lowerCasedItems}`);
					await this.refTablesStorageService.set(workfileId, lowerCaseTableName, lowerCasedItems);
				}
			}
		} else {
			console.warn('Picklist data not found in the Workfile');
		}
	}

	private groupByTableName(fusionReferenceTables: any[]): Map<string, any[]> {
		const groupedByTableName = new Map<string, any[]>();
		fusionReferenceTables.forEach((item: any) => {
			const tableName = item.reference_table_name;
			if (!groupedByTableName.has(tableName)) {
				groupedByTableName.set(tableName, []);
			}
			groupedByTableName.get(tableName)?.push(item);
		});
		return groupedByTableName;
	}

	private sanitizeData(resMap: { [key: string]: any[] }): { [key: string]: any[] } {
		WorkspaceDatabaseKeys.excludedItems.forEach((excludedItem: string) => {
			if (resMap.hasOwnProperty(excludedItem)) {
				delete resMap[excludedItem];
			}
		});
		return resMap;
	}


	public async getFusionUserId(): Promise<string | null> {
		return await this.storageService.get('loggedInFusionUserId');
	}
}
